const SIMPLE_PARAM_NAMES = ['from', 'to'];
const COMPLEX_PARAM_NAME = 'fromTo';
const PARAM_NAME_TO_IGNORE = 'langCountry';

const parameterNameMappings = {
    from: 'sourceCountry',
    to: 'targetCountry',
};

const prepositionMappings = {
    en: ['from', 'to'],
    ru: ['iz', 'v'],
    uk: ['z', 'v'],
    de: ['aus', 'nach'],
    cs: ['z', 'do'],
    it: ['da', 'a'],
    pl: ['z', 'do'],
    fr: ['de', 'vers'],
    ro: ['din', 'in'],
    tr: ['parayi', 'den'],
    es: ['de', 'a'],
    zh: ['cong', 'dao'],
    hi: ['from', 'to'],
    in: ['dari', 'ke'],
    id: ['dari', 'ke'],
    uz: ['from', 'to'],
    vi: ['tu', 'den'],
    pt: ['de', 'para'],
};

export const modifyReferralPageStrapiApi = (_language, location, _route, req) => {
    const code = req?.query?.ref;
    return code ? `${location}/${code}` : location;
};

export const modifyLandingPageStrapiApi = (language, location, route, req) => {
    const { params } = route;

    if (!params || !Object.keys(params).length) {
        return location;
    }

    if (params[PARAM_NAME_TO_IGNORE] && Object.keys(params).length === 1) {
        return location;
    }

    if (SIMPLE_PARAM_NAMES.every((paramName) => params[paramName])) {
        const searchParamsData = {};
        for (const [key, value] of Object.entries(params)) {
            searchParamsData[parameterNameMappings[key]] = value;
        }

        const sourceCurrency = req?.query?.send;
        const targetCurrency = req?.query?.receive;
        if (sourceCurrency) searchParamsData.sourceCurrency = sourceCurrency;
        if (targetCurrency) searchParamsData.targetCurrency = targetCurrency;

        const searchParams = new URLSearchParams(searchParamsData);
        const search = searchParams.toString();
        const modifiedLocation = `${location}?${search}`;
        return modifiedLocation;
    }

    if (params[COMPLEX_PARAM_NAME]) {
        const prepositions = prepositionMappings[language];

        if (!prepositions) {
            return location;
        }

        const pathWithQuery = params[COMPLEX_PARAM_NAME];
        const [path, query] = pathWithQuery.split('?');
        const pathParts = path.split('-');
        const sourcePrepositionIndex = pathParts.findIndex((part) => part === prepositions[0]);
        const targetPrepositionIndex = pathParts.findIndex((part) => part === prepositions[1]);

        const sourceCountry = pathParts.slice(sourcePrepositionIndex + 1, targetPrepositionIndex).join('-');
        const targetCountry = pathParts.slice(targetPrepositionIndex + 1).join('-');

        const { isRequest } = route.pattern.stateOptions;
        const operation = isRequest ? 'request' : 'send';

        // Берём валюты из query string роут-параметра, либо из query string самого запроса
        const routeSearchParams = query ? new URLSearchParams(query) : null;
        let sourceCurrency = routeSearchParams?.get('send') ?? req?.query?.send;
        let targetCurrency = routeSearchParams?.get('receive') ?? req?.query?.receive;

        let modifiedQuery = '';
        if (sourceCurrency && targetCurrency) {
            if (isRequest) {
                [sourceCurrency, targetCurrency] = [targetCurrency, sourceCurrency];
            }
            const modifiedParams = new URLSearchParams();
            modifiedParams.set('sourceCurrency', sourceCurrency);
            modifiedParams.set('targetCurrency', targetCurrency);
            modifiedQuery = modifiedParams.toString();
        }

        const modifiedLocation = `/api/calculator/${operation}/${sourceCountry}/${targetCountry}?${modifiedQuery}`;
        return modifiedLocation;
    }
};
